var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFieldMoney = function SvgFieldMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35935 12.4433V7.96438H0V6.84902H1.35935V5.41996H0V4.3046H1.35935V0H3.17181L4.82743 4.3046H6.88388V0H8.26065V4.3046H9.62V5.41996H8.26065V6.84902H9.62V7.96438H8.26065V12.4433H6.43076L4.77514 7.96438H2.7187V12.4433H1.35935ZM2.68384 4.3046H3.4158L2.68384 2.14359H2.61413L2.68384 4.3046ZM2.7187 6.84902H4.35688L3.83406 5.41996H2.68384L2.7187 6.84902ZM5.75109 6.84902H6.91873L6.88388 5.41996H5.22826L5.75109 6.84902ZM6.88388 9.98598H6.95359L6.9013 7.96438H6.16935L6.88388 9.98598Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFieldMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fieldMoney.dea11014.svg";
export { ForwardRef as ReactComponent };